import { IPayerUpdateRequest } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const updatePayer = async (id: string, payload: IPayerUpdateRequest) => {
  const response = await servicePayments.patch(`/payer/${id}`, payload);
  return response.data;
};
